<template>
  <div class="logon">
    <div class="FloatingWindow">
      <div class="loginbox">
        <div>
          <img src="../../assets/login/Group 13.webp" alt="" class="bg_img">
          <img src="../../assets/login/TuTu English.webp" alt="" class="img_tutu">
          <img src="../../assets/login/image 6.webp" alt="" class="img_star">

          <!-- 登录表单 -->

          <div class="login_content formbox" v-show="LoginOrReg">
            <div>
              <div class="form-item-custom">
                <div class="iptBox" :class="{ 'error': loginErrors.mobile }">
                  <input type="text" placeholder="Phone number" v-model="loginForm.mobile"
                    @blur="validateLoginField('mobile')">
                </div>
                <div v-if="loginErrors.mobile" class="error-message">{{ loginErrors.mobile }}</div>
              </div>
              <div class="form-item-custom">
                <div class="iptBox" :class="{ 'error': loginErrors.password }">
                  <input type="password" placeholder="Please enter your password" v-model="loginForm.password"
                    @blur="validateLoginField('password')">
                </div>
                <div v-if="loginErrors.password" class="error-message">{{ loginErrors.password }}</div>
              </div>
              <div class="img_btn">
                <img src="../../assets/login/loginbtn.webp" alt="" @click="loginIn()">
              </div>
            </div>
            <p @click="LoginOrReg = !LoginOrReg, clearIpt()">Register</p>
          </div>

          <!-- 注册表单 -->
          <div class="reg_content formbox" v-show="!LoginOrReg">
            <div>
              <div class="form-item-custom">
                <div class="iptBox" :class="{ 'error': registerErrors.mobile }">
                  <input type="text" placeholder="Phone number" v-model="registerForm.mobile"
                    @blur="validateRegisterField('mobile')">
                </div>
                <div v-if="registerErrors.mobile" class="error-message">{{ registerErrors.mobile }}</div>
              </div>
              <div class="form-item-custom">
                <div class="iptBox" :class="{ 'error': registerErrors.password }">
                  <input type="password" placeholder="Please enter your password" v-model="registerForm.password"
                    @blur="validateRegisterField('password')">
                </div>
                <div v-if="registerErrors.password" class="error-message">{{ registerErrors.password }}</div>
              </div>
              <div class="form-item-custom">
                <div class="iptBox" :class="{ 'error': registerErrors.confirmPassword }">
                  <input type="password" placeholder="Please confirm your password"
                    v-model="registerForm.confirmPassword" @blur="validateRegisterField('confirmPassword')">
                </div>
                <div v-if="registerErrors.confirmPassword" class="error-message">{{ registerErrors.confirmPassword }}
                </div>
              </div>
              <div class="img_btn">
                <img src="../../assets/login/regbtn.webp" alt="" @click="register()">
              </div>
            </div>
            <p @click="LoginOrReg = !LoginOrReg, clearIpt()">Log in</p>
          </div>
        </div>
        <img src="../../assets/login/image 7.webp" alt="" class="img_balloon">
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'
import { md5 } from 'js-md5';
import { getDeviceId } from '@/utils/getID'
//登录及注册接口引入
import { fnLogin, fnRegister } from '@/api/login'
import { setUserInfo } from '@/utils/userinfo'

const router = useRouter()

const fingerprint = ref<any>('')

const LoginOrReg = ref<boolean>(true);

function setfnRegister(data: object) {
  fnRegister(data)
    .then((val) => {
      if (val) {
        LoginOrReg.value = !LoginOrReg.value
      }
    })
}

function setfnLogin(data: object) {
  fnLogin(data)
    .then((val: any) => {
      if (val) {
        setUserInfo(val.data.userinfo)
        router.push('/')
      }
    })
}

// 登录表单数据
const loginForm = reactive({
  mobile: '',
  password: ''
});

// 注册表单数据
const registerForm = reactive({
  mobile: '',
  password: '',
  confirmPassword: ''
});

// 验证错误信息
const loginErrors = reactive({
  mobile: '',
  password: ''
});

const registerErrors = reactive({
  mobile: '',
  password: '',
  confirmPassword: ''
});

// 正则验证规则
const validationRules = {
  mobile: {
    pattern: /^1[3-9]\d{9}$/,
    message: '请输入正确的11位手机号'
  },
  password: {
    pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{6,30}$/,
    message: '密码只能包含英文数字，长度为6-30位'
  }
}

// 验证单个字段 - 登录表单
function validateLoginField(field: keyof typeof loginForm) {
  const value = loginForm[field]
  const rule = validationRules[field]

  if (!value.trim()) {
    loginErrors[field] = field === 'mobile' ? '请输入手机号' : '请输入密码'
    return false
  }

  if (!rule.pattern.test(value)) {
    loginErrors[field] = rule.message
    return false
  }

  loginErrors[field] = ''
  return true
}

// 验证单个字段 - 注册表单
function validateRegisterField(field: keyof typeof registerForm) {
  const value = registerForm[field]

  if (!value.trim()) {
    if (field === 'mobile') {
      registerErrors[field] = '请输入手机号'
    } else if (field === 'password') {
      registerErrors[field] = '请输入密码'
    } else {
      registerErrors[field] = '请再次输入密码'
    }
    return false
  }

  if (field === 'mobile') {
    if (!validationRules.mobile.pattern.test(value)) {
      registerErrors[field] = validationRules.mobile.message
      return false
    }
  } else if (field === 'password') {
    if (!validationRules.password.pattern.test(value)) {
      registerErrors[field] = validationRules.password.message
      return false
    }
  } else if (field === 'confirmPassword') {
    if (!validationRules.password.pattern.test(value)) {
      registerErrors[field] = validationRules.password.message
      return false
    }
    if (value !== registerForm.password) {
      registerErrors[field] = '两次输入的密码不一致'
      return false
    }
  }

  registerErrors[field] = ''
  return true
}

// 验证所有字段 - 登录表单
function validateAllLoginFields() {
  let isValid = true
  Object.keys(loginForm).forEach(field => {
    if (!validateLoginField(field as keyof typeof loginForm)) {
      isValid = false
    }
  })
  return isValid
}

// 验证所有字段 - 注册表单
function validateAllRegisterFields() {
  let isValid = true
  Object.keys(registerForm).forEach(field => {
    if (!validateRegisterField(field as keyof typeof registerForm)) {
      isValid = false
    }
  })
  return isValid
}

function clearIpt() {
  // 清空登录表单
  loginForm.mobile = '';
  loginForm.password = '';

  // 清空注册表单
  registerForm.mobile = '';
  registerForm.password = '';
  registerForm.confirmPassword = '';

  // 清除验证错误信息
  loginErrors.mobile = '';
  loginErrors.password = '';
  registerErrors.mobile = '';
  registerErrors.password = '';
  registerErrors.confirmPassword = '';
}

async function loginIn() {
  if (validateAllLoginFields()) {
    // 确保设备ID已获取
    if (!fingerprint.value) {
      fingerprint.value = await getDeviceId()
    }
    const registerData = {
      mobile: loginForm.mobile,
      password: md5(loginForm.password),
      userEquipmentKey: fingerprint.value
    };

    setfnLogin(registerData)
  } else {
    ElMessage.error('请检查输入信息');
  }
}

function register() {
  if (validateAllRegisterFields()) {
    // 提取注册数据，去掉confirmPassword字段
    const registerData = {
      mobile: registerForm.mobile,
      password: md5(registerForm.password)
    };
    setfnRegister(registerData)

    // 这里可以添加注册逻辑
  } else {
    ElMessage.error('请检查输入信息');
  }
}

onMounted(async () => {
  fingerprint.value = await getDeviceId()
})
</script>



<style lang="less" scoped>
@loginSize: 16px;
@loginFontWeight: 400;
@loginFontColor: #925C0B;
@inputBoxBgColor: white;

.logon {
  background-color: #808080;
  position: relative;
  width: 100%;
  height: 100vh;
  z-index: 1;

  >.FloatingWindow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;

    >.loginbox {
      position: relative;
      width: 540px;
      height: 480px;
      border-radius: 88px;
      background: linear-gradient(180deg, #7AEFF3 0%, #AFF8E5 100%);

      >.img_balloon {
        position: absolute;
        left: -35px;
        top: -49px;
      }

      >div {
        overflow: hidden;
        width: 540px;
        height: 480px;
        position: relative;
        border-radius: 88px;

        >.formbox {
          position: relative;
          z-index: 1001;
          margin: auto;
          width: 320px;
          margin-top: 138px;

          >p {
            text-align: center;
            color: @loginFontColor;
            font-size: @loginSize;
            cursor: pointer;
            margin-top: 20px;
          }

          // Element Plus 表单样式重置
          :deep(.el-form) {
            .el-form-item {
              margin-bottom: 20px;

              .el-form-item__content {
                line-height: normal;
              }

              .el-form-item__error {
                position: absolute;
                font-size: 12px;
                color: #f56c6c;
                line-height: 1.2;
                text-align: left;
                margin-left: 0;
              }
            }

            // 隐藏默认的表单项标签
            .el-form-item__label {
              display: none;
            }
          }

          .form-item-custom {
            position: relative;

            .iptBox {
              position: relative;
              width: 320px;
              height: 56px;
              padding: 0 24px;
              border-radius: 16px;
              background-color: @inputBoxBgColor;
              border: 1px solid #EBEBEB;
              transition: border-color 0.3s;
              margin-bottom: 20px;

              &.error {
                border-color: #F56C6C;
              }

              >input {
                border: none;
                outline: none;
                position: absolute;
                top: 50%;
                width: 80%;
                transform: translateY(-50%);
                font-weight: @loginFontWeight;
                font-size: 14px;
                background: transparent;
              }
            }

            .error-message {
              position: absolute;
              top: 61px;
              left: 0;
              font-size: 12px;
              color: #F56C6C;
              line-height: 1;
            }


          }

          .img_btn {
            margin-top: 20px;
            >img {
              cursor: pointer;
            }
          }
        }

        >img {
          position: absolute;
        }

        >.bg_img {
          bottom: 0;
          left: 0;
        }

        >.img_tutu {
          top: 74px;
          left: 50%;
          transform: translateX(-50%);
        }

        >.img_star {
          top: 19px;
          right: 121px;
        }

        >.img_close {
          right: 44px;
          top: 44px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>